<template>
    <div>
        <v-dialog
            :value="showDialog"
            :persistent="true"
            width="580"
        >
            <v-card class="AgeDialog">
                <v-card-title class="justify-center AgeDialog__title">Bylo vám už <nobr>18&nbsp;let?</nobr></v-card-title>
                <v-card-text>
                    <p class="text-center">Vstup na tyto stránky je povolen pouze osobám starším 18 let.</p>
                </v-card-text>
                <v-card-actions>
                    <span class="AgeDialog__box">
                        <v-btn color="primary" large text dark @click.stop="confirm">Bylo mi 18 let</v-btn>
                    </span>
                    <span class="AgeDialog__box">
                        <v-btn color="primary" large text dark>Opustit web</v-btn>
                    </span>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    const STORAGE_KEY = 'age-check';
    const STORAGE_VALUE = '1';

    export default {
        name: 'AgeDialog',
        data () {
            return {
                showDialog: localStorage.getItem(STORAGE_KEY) !== STORAGE_VALUE,
            };
        },
        mounted () {           
            if (this.showDialog === true) {
                document.getElementById("app").classList.add("blur");
            }            
        },
        methods: {
            confirm () {
                localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);                
                this.showDialog = false;
                document.getElementById("app").classList.remove("blur");
            },
        },
    }
</script>
